import { TailwindColor, NeutralColor } from '../types'

export const TAILWIND_COLORS: TailwindColor[] = [
  'red', 'orange', 'amber', 'yellow', 'lime',
  'green', 'emerald', 'teal', 'cyan', 'sky',
  'blue', 'indigo', 'violet', 'purple', 'fuchsia',
  'pink', 'rose'
]

export const NEUTRAL_COLORS: NeutralColor[] = [
  'slate', 'gray', 'zinc', 'neutral', 'stone'
]

// Tailwind color values for preview (500 shade)
export const COLOR_VALUES: Record<TailwindColor, string> = {
  slate: '#64748b',
  gray: '#6b7280',
  zinc: '#71717a',
  neutral: '#737373',
  stone: '#78716c',
  red: '#ef4444',
  orange: '#f97316',
  amber: '#f59e0b',
  yellow: '#eab308',
  lime: '#84cc16',
  green: '#22c55e',
  emerald: '#10b981',
  teal: '#14b8a6',
  cyan: '#06b6d4',
  sky: '#0ea5e9',
  blue: '#3b82f6',
  indigo: '#6366f1',
  violet: '#8b5cf6',
  purple: '#a855f7',
  fuchsia: '#d946ef',
  pink: '#ec4899',
  rose: '#f43f5e',
}

// Lighter shade (400) for hover states
export const COLOR_VALUES_LIGHT: Record<TailwindColor, string> = {
  slate: '#94a3b8',
  gray: '#9ca3af',
  zinc: '#a1a1aa',
  neutral: '#a3a3a3',
  stone: '#a8a29e',
  red: '#f87171',
  orange: '#fb923c',
  amber: '#fbbf24',
  yellow: '#facc15',
  lime: '#a3e635',
  green: '#4ade80',
  emerald: '#34d399',
  teal: '#2dd4bf',
  cyan: '#22d3ee',
  sky: '#38bdf8',
  blue: '#60a5fa',
  indigo: '#818cf8',
  violet: '#a78bfa',
  purple: '#c084fc',
  fuchsia: '#e879f9',
  pink: '#f472b6',
  rose: '#fb7185',
}

// Darker shade (600) for active/pressed states
export const COLOR_VALUES_DARK: Record<TailwindColor, string> = {
  slate: '#475569',
  gray: '#4b5563',
  zinc: '#52525b',
  neutral: '#525252',
  stone: '#57534e',
  red: '#dc2626',
  orange: '#ea580c',
  amber: '#d97706',
  yellow: '#ca8a04',
  lime: '#65a30d',
  green: '#16a34a',
  emerald: '#059669',
  teal: '#0d9488',
  cyan: '#0891b2',
  sky: '#0284c7',
  blue: '#2563eb',
  indigo: '#4f46e5',
  violet: '#7c3aed',
  purple: '#9333ea',
  fuchsia: '#c026d3',
  pink: '#db2777',
  rose: '#e11d48',
}

// Very light shade (100) for backgrounds
export const COLOR_VALUES_BG: Record<TailwindColor, string> = {
  slate: '#f1f5f9',
  gray: '#f3f4f6',
  zinc: '#f4f4f5',
  neutral: '#f5f5f5',
  stone: '#f5f5f4',
  red: '#fee2e2',
  orange: '#ffedd5',
  amber: '#fef3c7',
  yellow: '#fef9c3',
  lime: '#ecfccb',
  green: '#dcfce7',
  emerald: '#d1fae5',
  teal: '#ccfbf1',
  cyan: '#cffafe',
  sky: '#e0f2fe',
  blue: '#dbeafe',
  indigo: '#e0e7ff',
  violet: '#ede9fe',
  purple: '#f3e8ff',
  fuchsia: '#fae8ff',
  pink: '#fce7f3',
  rose: '#ffe4e6',
}

// Neutral 50 for light backgrounds
export const NEUTRAL_BG: Record<NeutralColor, string> = {
  slate: '#f8fafc',
  gray: '#f9fafb',
  zinc: '#fafafa',
  neutral: '#fafafa',
  stone: '#fafaf9',
}

// Neutral 900 for text
export const NEUTRAL_TEXT: Record<NeutralColor, string> = {
  slate: '#0f172a',
  gray: '#111827',
  zinc: '#18181b',
  neutral: '#171717',
  stone: '#1c1917',
}

// Neutral 600 for secondary text
export const NEUTRAL_TEXT_SECONDARY: Record<NeutralColor, string> = {
  slate: '#475569',
  gray: '#4b5563',
  zinc: '#52525b',
  neutral: '#525252',
  stone: '#57534e',
}

// Neutral 200 for borders
export const NEUTRAL_BORDER: Record<NeutralColor, string> = {
  slate: '#e2e8f0',
  gray: '#e5e7eb',
  zinc: '#e4e4e7',
  neutral: '#e5e5e5',
  stone: '#e7e5e4',
}
